import { useEffect } from "react";
import { useCookieConsentStore } from "../stores/useCookieConsentStore";

function CookieConsentBanner() {
    const showBanner = useCookieConsentStore((state) => state.showBanner);

    const handleAccept = async () => {
        useCookieConsentStore.getState().setCookieConsent(true);
    }

    const handleDecline = async () => {
        useCookieConsentStore.getState().setCookieConsent(false);
    }

    useEffect(() => {
        if (showBanner) {
            const banner = document.getElementById('cookieBanner');
            document.body.style.paddingBottom = `${banner.offsetHeight}px`;
        } else {
            document.body.style.paddingBottom = '0';
        }
    }, [showBanner]);

    return (
        <>
            {showBanner &&
                <div id="cookieBanner" className="notification is-success is-light is-fixed-bottom" style={{
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    zIndex: 1000,
                    margin: 0,
                    borderRadius: 0
                }}>
                    <div className="container">
                        <div>
                            <p>
                                <div className="is-size=5 has-text-weight-bold">Cookie Consent</div>
                                <div>
                                    <span className="has-text-weight-strong">Necessary:</span> To remember your choice on this banner, our site
                                    uses essential storage in your browser. We do not set any other first-party cookies.
                                </div>
                                <div className="mt-2">
                                    <span className="has-text-weight-strong">Third Party:</span> To enable signing in with Google, Microsoft and/or Yahoo!, we need your
                                    consent to allow third parties (Google) to set cookies. As an alternative, you can sign in using email and password.
                                </div>
                                <div className="mt-2">
                                    You can change your preferences at any time through the <span className="has-text-weight-bold">About Us</span> menu and selecting <span className="has-text-weight-bold">Manage Cookies</span>
                                </div>
                                <div className="mt-2">
                                    You can learn more in our <a href="/privacy">Privacy Policy</a>.
                                </div>
                            </p>
                        </div>
                        <div className="columns is-vcentered mb-5 mt-3">
                            <div className="column is-narrow">
                                <div className="buttons">
                                    <button
                                        className="button is-primary is-small"
                                        onClick={handleAccept}
                                    >
                                        Allow Third Party
                                    </button>
                                    <button
                                        className="button is-dark is-outlined is-small"
                                        onClick={handleDecline}
                                    >
                                        Decline
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

export default CookieConsentBanner;